import React from 'react';
import { parameterStatuses } from '../constants';

export function CurrentConfigureValue({ status, currentValue, dirty }) {
  return (dirty || status !== parameterStatuses.LIVE)
    && (
      <div className="current-value">
        Current value:
        {' '}
        {currentValue}
      </div>
    );
}
